import { useRef } from 'react';
import styled from 'styled-components';
import { ICustomerUI } from 'types/customer';
import ModalCustomerAppointments, { ModalCustomerAppointmentRef } from './CustomerAppointments';
import CustomerSearchInput from './CustomerSearchInput';
const CustomerSearch = () => {
  const modalRef = useRef<ModalCustomerAppointmentRef>(null);
  const setValue = (_value: ICustomerUI | null) => {
    modalRef.current?.open(_value);
  };

  return (
    <>
      <Container>
        <CustomerSearchInput
          v2NewApt
          preventUnknown
          autoOpenAddWhenNotFound
          v2
          onChange={setValue}
        />
      </Container>
      <ModalCustomerAppointments ref={modalRef} />
    </>

  );
};

export default CustomerSearch;
const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;